import { UK, US_CON } from '../../constants';
import experiments from '../../experiments';
import { isExperimentEnabled } from '../../user_context_helpers';

export function shouldDisplayNewHomepageSearch(user) {
  return isExperimentEnabled(user, experiments.NEW_HOMEPAGE_SEARCH_3) && [US_CON, UK].includes(user.shippingRegionCode);
}

export const DISPLAY_CATEGORIES_TRANSLATION_KEYS = [
  'electricGuitars',
  'bassGuitars',
  'pedals',
  'keysAndSynths',
  'amplifiers',
  'drums',
  'recordingGear',
];

export const MARKETPLACE_LINK_PARAMS_BY_TRANSLATION_KEY = {
  electricGuitars: {
    allElectricGuitars: { product_type: 'electric-guitars' },
    solidBody: { product_type: 'electric-guitars', category: 'solid-body' },
    archtop: { product_type: 'electric-guitars', category: 'archtop' },
    vintage: { product_type: 'electric-guitars', year_max: '1980' },
    semiHollow: { product_type: 'electric-guitars', category: 'semi-hollow' },
  },
  bassGuitars: {
    allBassGuitars: { product_type: 'bass-guitars' },
    fretless: { product_type: 'bass-guitars', category: 'fretless' },
    leftHanded: { product_type: 'bass-guitars', category: 'left-handed' },
    acoustic: { product_type: 'bass-guitars', category: 'acoustic-bass-guitars' },
    fourString: { product_type: 'bass-guitars', category: '4-string' },
    fiveStringAndMore: { product_type: 'bass-guitars', category: '5-string-or-more' },
    activeElectronics: { product_type: 'bass-guitars', category: 'active-electronics' },
  },
  pedals: {
    allPedals: { product_type: 'effects-and-pedals' },
    overdrive: { product_type: 'effects-and-pedals', category: 'overdrive-and-boost' },
    distortion: { product_type: 'effects-and-pedals', category: 'distortion' },
    fuzz: { product_type: 'effects-and-pedals', category: 'fuzz' },
    delay: { product_type: 'effects-and-pedals', category: 'delay' },
    wah: { product_type: 'effects-and-pedals', category: 'wahs-and-filters' },
  },
  keysAndSynths: {
    allKeysAndSynths: { product_type: 'keyboards-and-synths' },
    eurorack: { product_type: 'keyboards-and-synths', category: 'eurorack' },
    modular: { product_type: 'keyboards-and-synths', category: 'modular-synths' },
    digital: { product_type: 'keyboards-and-synths', category: 'digital-synths' },
    analog: { product_type: 'keyboards-and-synths', category: 'analog-synths' },
    rackmount: { product_type: 'keyboards-and-synths', category: 'rackmount-synths' },
  },
  amplifiers: {
    allAmplifiers: { product_type: 'amps' },
    guitarCombos: { product_type: 'amps', category: 'guitar-combos' },
    guitarHeads: { product_type: 'amps', category: 'guitar-heads' },
    guitarCabinets: { product_type: 'amps', category: 'guitar-cabinets' },
    modelingAmps: { product_type: 'amps', category: 'modeling-amps' },
  },
  drums: {
    allDrums: { product_type: 'drums-and-percussion' },
    drumSets: { product_type: 'drums-and-percussion', category: 'full-acoustic-kits' },
    snares: { product_type: 'drums-and-percussion', category: 'snare' },
    cymbals: { product_type: 'drums-and-percussion', category: 'cymbals' },
    drumMachinesAndSamplers: { product_type: 'drums-and-percussion', category: 'drum-machines-and-samplers' },
    electronicDrumSets: { product_type: 'drums-and-percussion', category: 'full-electronic-kits' },
    vintage: { product_type: 'drums-and-percussion', category: 'acoustic-drums', year_max: '1989', condition: 'used' },
  },
  recordingGear: {
    allRecordingGear: { product_type: 'pro-audio' },
    microphones: { product_type: 'pro-audio', category: 'microphones' },
    studioMonitors: { product_type: 'pro-audio', category: 'studio-monitors' },
    recordingInterfaces: { product_type: 'pro-audio', category: 'interfaces' },
    mixers: { product_type: 'pro-audio', category: 'mixers' },
  },
};
